export const ImageColors = {
    DARK: 'Dark',
    LIGHT: 'Light',
};

export default ImageColors;
